export interface Anime {
  id: string;
  title: string;
  titleEn: string;
  cover: string;
  category: string;
  tags: string[];
  rating: number;
  episodeCount: number;
  updatedEpisode: number;
  status: string;
  description: string;
  year: number;
  season: string;
  studio: string;
  views: number;
  updateDate: string;
  episodes: Episode[];
}

export interface Episode {
  id: string;
  number: number;
  title: string;
  duration: string;
}

export const categories = [
  { key: 'rexue', label: '热血', icon: 'ri-fire-line', color: 'primary' },
  { key: 'lianai', label: '恋爱', icon: 'ri-heart-line', color: 'accent' },
  { key: 'qihuan', label: '奇幻', icon: 'ri-magic-line', color: 'primary' },
  { key: 'gaoxiao', label: '搞笑', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { key: 'xuanyi', label: '悬疑', icon: 'ri-search-eye-line', color: 'primary' },
  { key: 'richang', label: '日常', icon: 'ri-sun-line', color: 'accent' },
  { key: 'zhandou', label: '战斗', icon: 'ri-sword-line', color: 'primary' },
  { key: 'kehuan', label: '科幻', icon: 'ri-rocket-line', color: 'accent' },
];

export const animeList: Anime[] = [
  {
    id: '1',
    title: '鬼灭之刃 柱训练篇',
    titleEn: 'Demon Slayer: Hashira Training Arc',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20style%20poster%2C%20young%20warrior%20with%20dark%20hair%20and%20green%20checkered%20haori%2C%20holding%20katana%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20red%20gradient%20background%2C%20anime%20key%20visual%20art%20style%2C%20dramatic%20lighting%2C%20clean%20composition&width=600&height=840&seq=anime-cover-01&orientation=portrait',
    category: 'rexue',
    tags: ['热血', '战斗', '冒险'],
    rating: 9.7,
    episodeCount: 8,
    updatedEpisode: 5,
    status: '连载中',
    description: '时值日本大正时期。传说太阳下山后，有恶鬼出没吃人。亦有猎鬼人斩杀恶鬼、保护人们。卖炭少年炭治郎，他那平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。母亲与四个弟妹惨遭杀害，而与他一起生还的妹妹祢豆子亦异变成凶暴的鬼。在猎鬼人的指引下，立志成为猎鬼人的炭治郎与变成鬼却尚存理智的祢豆子踏上了旅程。通过艰苦的剑术修行与赌命试炼，炭治郎成为了鬼猎人组织"鬼杀队"的一员。为了让妹妹祢豆子变回人类，为了讨伐杀害家人的恶鬼，为了斩断悲伤的连锁，少年与鬼的战斗不曾停歇。',
    year: 2024,
    season: '春季',
    studio: 'ufotable',
    views: 12580000,
    updateDate: '2026-08-09',
    episodes: [
      { id: 'e1-1', number: 1, title: '为了讨伐鬼舞辻无惨', duration: '48分钟' },
      { id: 'e1-2', number: 2, title: '水柱·富冈义勇的伤痛', duration: '24分钟' },
      { id: 'e1-3', number: 3, title: '炭治郎痊愈！投身训练', duration: '24分钟' },
      { id: 'e1-4', number: 4, title: '面带笑容的炭治郎', duration: '24分钟' },
      { id: 'e1-5', number: 5, title: '不惜吃了你', duration: '24分钟' },
      { id: 'e1-6', number: 6, title: '鬼杀队最强', duration: '24分钟' },
    ],
  },
  {
    id: '2',
    title: '咒术回战 第二季',
    titleEn: 'Jujutsu Kaisen Season 2',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20jujutsu%20sorcerer%20style%20poster%2C%20white-haired%20character%20with%20blindfold%2C%20supernatural%20energy%20effects%2C%20dark%20urban%20fantasy%20setting%2C%20purple%20and%20blue%20cursed%20energy%20visuals%2C%20anime%20key%20visual%2C%20dramatic%20composition%2C%20clean%20background&width=600&height=840&seq=anime-cover-02&orientation=portrait',
    category: 'zhandou',
    tags: ['战斗', '奇幻', '热血'],
    rating: 9.5,
    episodeCount: 23,
    updatedEpisode: 23,
    status: '已完结',
    description: '少年战斗着——「为了寻求正确的死亡」。辛酸·后悔·耻辱，人类产生的负面情感，化为诅咒，潜入日常生活。诅咒是蔓延于世界的祸源，最糟糕的情况下，会让人类踏入死亡。并且，诅咒只能以诅咒祓除。拥有惊人身体能力的少年·虎杖悠仁原本过着普通的高中生活。某天，为拯救遭受「咒物」袭击的同伴，他吞下了特级咒物「两面宿傩之指」，使诅咒之王的灵魂寄宿在了自己体内。',
    year: 2023,
    season: '夏季',
    studio: 'MAPPA',
    views: 15600000,
    updateDate: '2026-08-08',
    episodes: [
      { id: 'e2-1', number: 1, title: '怀玉', duration: '24分钟' },
      { id: 'e2-2', number: 2, title: '怀玉-贰-', duration: '24分钟' },
      { id: 'e2-3', number: 3, title: '怀玉-叁-', duration: '24分钟' },
      { id: 'e2-4', number: 4, title: '怀玉-肆-', duration: '24分钟' },
    ],
  },
  {
    id: '3',
    title: '葬送的芙莉莲',
    titleEn: 'Frieren: Beyond Journey\'s End',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20fantasy%20poster%2C%20elf%20girl%20with%20silver%20hair%20and%20staff%2C%20wearing%20white%20robe%2C%20peaceful%20meadow%20background%20with%20warm%20sunlight%2C%20nostalgic%20atmosphere%2C%20soft%20pastel%20colors%2C%20anime%20key%20visual%2C%20gentle%20composition&width=600&height=840&seq=anime-cover-03&orientation=portrait',
    category: 'qihuan',
    tags: ['奇幻', '冒险', '治愈'],
    rating: 9.8,
    episodeCount: 28,
    updatedEpisode: 28,
    status: '已完结',
    description: '打倒魔王后，勇者一行人中的魔法使芙莉莲作为长生的精灵，踏上了「了解人类」的旅途。勇者辛美尔死后20年，芙莉莲再次踏上曾经的冒险之路。与新的同伴一起，追寻过去的足迹。',
    year: 2023,
    season: '秋季',
    studio: 'MADHOUSE',
    views: 18900000,
    updateDate: '2026-08-07',
    episodes: [
      { id: 'e3-1', number: 1, title: '冒险的结束', duration: '24分钟' },
      { id: 'e3-2', number: 2, title: '未必是魔术', duration: '24分钟' },
      { id: 'e3-3', number: 3, title: '杀人魔法', duration: '24分钟' },
    ],
  },
  {
    id: '4',
    title: '辉夜大小姐想让我告白',
    titleEn: 'Kaguya-sama: Love is War',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20romantic%20comedy%20anime%20poster%2C%20elegant%20schoolgirl%20with%20long%20black%20hair%20and%20red%20ribbon%2C%20student%20council%20setting%2C%20romantic%20tension%2C%20soft%20pink%20and%20warm%20lighting%2C%20anime%20key%20visual%2C%20refined%20composition&width=600&height=840&seq=anime-cover-04&orientation=portrait',
    category: 'lianai',
    tags: ['恋爱', '搞笑', '日常'],
    rating: 9.4,
    episodeCount: 13,
    updatedEpisode: 13,
    status: '已完结',
    description: '在名门高中秀知院学园，学生会会长白银御行与副会长四宫辉夜相遇了。两个天才的恋爱头脑战，每天围绕着「如何让对方先告白」而展开。',
    year: 2019,
    season: '冬季',
    studio: 'A-1 Pictures',
    views: 9200000,
    updateDate: '2026-08-06',
    episodes: [
      { id: 'e4-1', number: 1, title: '想让你约我去看电影', duration: '24分钟' },
      { id: 'e4-2', number: 2, title: '辉夜大小姐想让我猜谜', duration: '24分钟' },
    ],
  },
  {
    id: '5',
    title: '间谍过家家',
    titleEn: 'Spy x Family',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20poster%2C%20elegant%20man%20in%20suit%20with%20pink-haired%20girl%20and%20woman%20with%20black%20dress%2C%20warm%20family%20theme%20with%20retro%20aesthetic%2C%20mid-century%20modern%20design%20elements%2C%20anime%20key%20visual%2C%20heartwarming%20composition&width=600&height=840&seq=anime-cover-05&orientation=portrait',
    category: 'gaoxiao',
    tags: ['搞笑', '日常', '温馨'],
    rating: 9.3,
    episodeCount: 25,
    updatedEpisode: 25,
    status: '已完结',
    description: '为了执行任务，最强间谍黄昏必须组建临时家庭。他收养的女儿阿尼亚是超能力者，假结婚的妻子约尔是杀手。三人互相隐瞒身份，却成为了真正的家人。',
    year: 2022,
    season: '春季',
    studio: 'WIT STUDIO × CloverWorks',
    views: 14300000,
    updateDate: '2026-08-08',
    episodes: [
      { id: 'e5-1', number: 1, title: '行动代号：梟', duration: '24分钟' },
      { id: 'e5-2', number: 2, title: '选妻', duration: '24分钟' },
    ],
  },
  {
    id: '6',
    title: '死神 千年血战篇',
    titleEn: 'Bleach: Thousand-Year Blood War',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20action%20poster%2C%20orange-haired%20teenager%20with%20large%20sword%2C%20dark%20gothic%20shinigami%20uniform%2C%20dramatic%20spiritual%20energy%20effects%2C%20epic%20battle%20atmosphere%2C%20anime%20key%20visual%2C%20cinematic%20lighting&width=600&height=840&seq=anime-cover-06&orientation=portrait',
    category: 'rexue',
    tags: ['热血', '战斗', '冒险'],
    rating: 9.2,
    episodeCount: 52,
    updatedEpisode: 39,
    status: '连载中',
    description: '重获死神力量的黑崎一护，正式回归代理死神的岗位。此时，无形帝国向尸魂界宣战。他们向死神们布告——「五天后，尸魂界将被无形帝国消灭」。',
    year: 2022,
    season: '秋季',
    studio: 'Studio Pierrot',
    views: 10200000,
    updateDate: '2026-08-09',
    episodes: [
      { id: 'e6-1', number: 1, title: 'THE BLOOD WARFARE', duration: '24分钟' },
      { id: 'e6-2', number: 2, title: 'FOUNDATION STONES', duration: '24分钟' },
    ],
  },
  {
    id: '7',
    title: '约定的梦幻岛',
    titleEn: 'The Promised Neverland',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20mystery%20thriller%20poster%2C%20three%20children%20looking%20at%20viewer%20with%20determined%20expressions%2C%20dark%20forest%20background%2C%20ominous%20atmosphere%2C%20gothic%20orphanage%20setting%2C%20anime%20key%20visual%2C%20dramatic%20lighting%2C%20clean%20composition&width=600&height=840&seq=anime-cover-07&orientation=portrait',
    category: 'xuanyi',
    tags: ['悬疑', '冒险', '剧情'],
    rating: 9.1,
    episodeCount: 12,
    updatedEpisode: 12,
    status: '已完结',
    description: '在孤儿院快乐生活的孩子们，某天发现了可怕的真相——他们只是鬼的食用儿。艾玛、诺曼和雷三人下定决心要带领所有孩子逃出孤儿院。',
    year: 2019,
    season: '冬季',
    studio: 'CloverWorks',
    views: 8700000,
    updateDate: '2026-08-05',
    episodes: [
      { id: 'e7-1', number: 1, title: '121045', duration: '24分钟' },
      { id: 'e7-2', number: 2, title: '131045', duration: '24分钟' },
    ],
  },
  {
    id: '8',
    title: '孤独摇滚！',
    titleEn: 'Bocchi the Rock!',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20music%20poster%2C%20pink-haired%20shy%20girl%20holding%20electric%20guitar%2C%20band%20performance%20theme%2C%20warm%20and%20energetic%20atmosphere%2C%20school%20uniform%2C%20anime%20key%20visual%2C%20cute%20and%20soft%20art%20style&width=600&height=840&seq=anime-cover-08&orientation=portrait',
    category: 'richang',
    tags: ['日常', '音乐', '搞笑'],
    rating: 9.5,
    episodeCount: 12,
    updatedEpisode: 12,
    status: '已完结',
    description: '极度社恐的少女后藤一里，梦想成为乐队吉他手。她在网上以「吉他英雄」的名义发布演奏视频而小有名气。某天，她被一位鼓手少女拉入了乐队……',
    year: 2022,
    season: '秋季',
    studio: 'CloverWorks',
    views: 11500000,
    updateDate: '2026-08-07',
    episodes: [
      { id: 'e8-1', number: 1, title: '孤独的转校生', duration: '24分钟' },
      { id: 'e8-2', number: 2, title: '明天见', duration: '24分钟' },
    ],
  },
  {
    id: '9',
    title: '进击的巨人 最终季',
    titleEn: 'Attack on Titan Final Season',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20epic%20action%20poster%2C%20dark-haired%20soldier%20with%20ODM%20gear%2C%20massive%20titan%20in%20background%2C%20apocalyptic%20setting%2C%20dramatic%20cinematic%20lighting%2C%20anime%20key%20visual%2C%20intense%20atmosphere%2C%20clean%20composition&width=600&height=840&seq=anime-cover-09&orientation=portrait',
    category: 'zhandou',
    tags: ['战斗', '悬疑', '剧情'],
    rating: 9.6,
    episodeCount: 35,
    updatedEpisode: 35,
    status: '已完结',
    description: '城墙外潜伏着以人类为食的巨人。艾伦·耶格尔目睹母亲被巨人吞食后，立誓要将所有巨人驱逐出去。然而随着真相逐渐揭开，世界的残酷远超他的想象。',
    year: 2020,
    season: '冬季',
    studio: 'MAPPA',
    views: 22000000,
    updateDate: '2026-08-09',
    episodes: [
      { id: 'e9-1', number: 1, title: '大海的另一边', duration: '24分钟' },
      { id: 'e9-2', number: 2, title: '暗夜列车', duration: '24分钟' },
    ],
  },
  {
    id: '10',
    title: '夏日重现',
    titleEn: 'Summer Time Rendering',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20suspense%20poster%2C%20young%20man%20on%20beach%20at%20sunset%2C%20mysterious%20island%20setting%2C%20time%20loop%20theme%2C%20warm%20summer%20colors%2C%20hints%20of%20darkness%2C%20anime%20key%20visual%2C%20atmospheric%20composition&width=600&height=840&seq=anime-cover-10&orientation=portrait',
    category: 'xuanyi',
    tags: ['悬疑', '奇幻', '冒险'],
    rating: 9.4,
    episodeCount: 25,
    updatedEpisode: 25,
    status: '已完结',
    description: '青梅竹马潮的死讯传来后，慎平回到了阔别已久的故乡和歌山市日都岛。然而在葬礼上，慎平感受到了岛上隐藏的某种不协调感……',
    year: 2022,
    season: '春季',
    studio: 'OLM',
    views: 9600000,
    updateDate: '2026-08-06',
    episodes: [
      { id: 'e10-1', number: 1, title: '再见夏天', duration: '24分钟' },
      { id: 'e10-2', number: 2, title: '阴影', duration: '24分钟' },
    ],
  },
  {
    id: '11',
    title: '某科学的超电磁炮T',
    titleEn: 'A Certain Scientific Railgun T',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20science%20fiction%20poster%2C%20schoolgirl%20with%20brown%20short%20hair%20surrounded%20by%20electricity%20effects%2C%20futuristic%20academy%20city%20background%2C%20action%20pose%2C%20anime%20key%20visual%2C%20dynamic%20lightning%20effects%2C%20clean%20composition&width=600&height=840&seq=anime-cover-11&orientation=portrait',
    category: 'kehuan',
    tags: ['科幻', '战斗', '日常'],
    rating: 9.0,
    episodeCount: 25,
    updatedEpisode: 25,
    status: '已完结',
    description: '总面积约东京都三分之一的学园都市。在这座超能力者云集的学校里，最强的电击使者御坂美琴迎来了新的挑战。',
    year: 2020,
    season: '冬季',
    studio: 'J.C.STAFF',
    views: 7800000,
    updateDate: '2026-08-04',
    episodes: [
      { id: 'e11-1', number: 1, title: '超能力者', duration: '24分钟' },
      { id: 'e11-2', number: 2, title: '大覇星祭', duration: '24分钟' },
    ],
  },
  {
    id: '12',
    title: '迷宫饭',
    titleEn: 'Delicious in Dungeon',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20fantasy%20cooking%20poster%2C%20adventurers%20cooking%20monsters%20in%20dungeon%2C%20warm%20campfire%20lighting%2C%20mix%20of%20food%20and%20fantasy%20elements%2C%20anime%20key%20visual%2C%20unique%20and%20fun%20composition&width=600&height=840&seq=anime-cover-12&orientation=portrait',
    category: 'qihuan',
    tags: ['奇幻', '搞笑', '美食'],
    rating: 9.3,
    episodeCount: 24,
    updatedEpisode: 24,
    status: '已完结',
    description: '在迷宫中救回被巨龙吞食的妹妹——为此，冒险者莱欧斯一行人踏上了征途。但是，他们没有带食物！在迷宫深处以魔物为食的「迷宫饭」冒险开始了！',
    year: 2024,
    season: '冬季',
    studio: 'TRIGGER',
    views: 10800000,
    updateDate: '2026-08-08',
    episodes: [
      { id: 'e12-1', number: 1, title: '水煮大蝎子', duration: '24分钟' },
      { id: 'e12-2', number: 2, title: '烤巴西利斯克', duration: '24分钟' },
    ],
  },
];

export const trendingIds = ['1', '9', '3', '6', '2', '8', '12', '5'];

export const latestAnimeIds = ['1', '6', '2', '9', '12', '5', '10', '3'];

export const rankingIds = ['3', '9', '1', '2', '8', '12', '4', '10', '5', '7'];

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  cover: string;
  author: string;
  date: string;
  category: string;
  tags: string[];
  relatedAnimeIds: string[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '2024年最值得期待的10部新番动画',
    excerpt: '新的一年，新的番剧！本文为你盘点2024年最值得期待的10部新番动画，从热血战斗到治愈日常，总有一部适合你。',
    content: '2024年是一个动画大年，众多备受期待的作品即将登场。从经典IP的续作到全新原创动画，今年的阵容可谓豪华。\n\n首先不得不提的就是《鬼灭之刃》的最新篇章。在经历了刀匠村篇后，炭治郎一行人即将前往柱训练。ufotable的制作水准一如既往地令人惊叹，每一帧都堪称艺术品。\n\n其次是终于回归的《咒术回战》后续篇章。涉谷事变后的世界格局发生了翻天覆地的变化，虎杖悠仁的命运将何去何从？MAPPA的制作团队将继续为观众呈现精彩的战斗场面。\n\n《葬送的芙莉莲》作为2023年秋季的最大黑马，其后续故事同样值得期待。这部作品以细腻的情感描写和深刻的生命思考打动了无数观众。\n\n除此之外，《迷宫饭》、《失忆投捕》等作品也展现出了极高的制作水准。2024年的新番市场可谓是百花齐放。',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20collage%20of%20popular%202024%20anime%20characters%2C%20colorful%20and%20vibrant%2C%20mosaic%20style%20arrangement%2C%20warm%20gradient%20background%2C%20anime%20art%20style%2C%20promotional%20visual&width=1200&height=630&seq=article-cover-01&orientation=landscape',
    author: '动漫编辑·小明',
    date: '2026-08-10',
    category: '新番推荐',
    tags: ['新番', '2024', '推荐'],
    relatedAnimeIds: ['1', '2', '3'],
  },
  {
    id: 'a2',
    title: '鬼灭之刃为何能成为现象级作品？深度解析',
    excerpt: '从漫画到动画，再到剧场版，《鬼灭之刃》创造了一个又一个奇迹。本文深度解析鬼灭之刃的成功密码。',
    content: '《鬼灭之刃》的成功绝非偶然。从漫画连载初期的不温不火，到动画化后的爆发式增长，这部作品走过了一段令人惊叹的旅程。\n\n制作质量是关键因素之一。ufotable以其精湛的动画制作技艺，将原作中的战斗场面提升到了一个新的高度。尤其是「火之神神乐」的演出，融合了浮世绘风格的CG特效与传统手绘动画，创造了独特的视觉体验。\n\n人物塑造同样是鬼灭之刃成功的重要因素。炭治郎的温柔与坚韧、祢豆子的纯真与强大、善逸的怯懦与爆发、伊之助的野性与成长，每个角色都有鲜明的个性和完整的成长弧线。\n\n此外,作品传递的家族之爱与人性光辉，跨越了年龄和国界的限制，引发了广泛的情感共鸣。鬼杀队成员之间守望相助的情谊，以及炭治郎对妹妹永不放弃的守护，都让观众在战斗之外感受到温暖。',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20style%2C%20epic%20flame%20sword%20technique%20with%20water%20dragon%20effect%2C%20dramatic%20cinematic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20anime%20art%20style%2C%20clean%20composition&width=1200&height=630&seq=article-cover-02&orientation=landscape',
    author: '资深动漫评论·小红',
    date: '2026-08-09',
    category: '深度分析',
    tags: ['鬼灭之刃', '深度分析', '现象级'],
    relatedAnimeIds: ['1'],
  },
  {
    id: 'a3',
    title: '治愈系动漫推荐：被生活压垮时，这些番剧给你温暖',
    excerpt: '生活不易，好在还有动漫治愈心灵。推荐5部温暖人心的治愈系动漫，让疲惫的你找到内心的平静。',
    content: '在快节奏的现代生活中，每个人都难免会感到疲惫和压力。这时候，一部温暖治愈的动漫或许就是最好的心灵慰藉。\n\n《葬送的芙莉莲》虽然开篇有些悲伤，但整部作品的核心是温暖而治愈的。精灵芙莉莲在勇者辛美尔离世后，踏上了「了解人类」的旅程。沿途的风景、与过去同伴的回忆、新伙伴的陪伴，都让人感受到生命的美好与珍贵。\n\n《间谍过家家》用幽默的方式包裹着温暖的亲情内核。三个身份各异的人组成临时家庭，却在相处中逐渐成为真正的家人。阿尼亚的天真可爱、黄昏的温柔守护、约尔的笨拙关怀，每一集都让人会心一笑。\n\n《孤独摇滚！》则是献给所有内向者的一封情书。后藤一里的成长之路虽然磕磕绊绊，但她从不放弃对音乐的热爱。这部作品让人相信，即使是最孤独的人，也能找到属于自己的舞台。',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20healing%20slice%20of%20life%20style%2C%20peaceful%20countryside%20scene%20with%20warm%20sunlight%2C%20soft%20pastel%20colors%2C%20cozy%20and%20calm%20atmosphere%2C%20anime%20art%20style%2C%20gentle%20composition&width=1200&height=630&seq=article-cover-03&orientation=landscape',
    author: '动漫编辑·小花',
    date: '2026-08-08',
    category: '番剧推荐',
    tags: ['治愈', '推荐', '日常'],
    relatedAnimeIds: ['3', '5', '8'],
  },
];

export const faqList = [
  {
    question: '91动漫是否需要注册才能观看？',
    answer: '91动漫平台大部分番剧资源支持免费在线观看，无需注册即可享受高清流畅的追番体验。注册账号后可以收藏喜爱的番剧、同步观看记录，获得更个性化的服务。',
  },
  {
    question: '91动漫的资源是否为正版？',
    answer: '是的，91动漫始终坚持正版路线，所有番剧资源均来自正版授权渠道。我们与国内外多家版权方建立了深度合作关系，确保为用户提供合法、优质的动漫内容。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '91动漫支持PC端（Windows/Mac）、移动端（iOS/Android手机和平板）、智能电视等多种设备。页面采用响应式设计，无论使用哪种设备，都能获得流畅的观看体验。',
  },
  {
    question: '番剧更新频率是怎样的？',
    answer: '91动漫每日更新最新番剧，热门连载番剧与日本同步更新。通常情况下，新番在日本播出后24小时内即可在91动漫观看带中文字幕的版本。具体更新进度可在番剧详情页查看。',
  },
  {
    question: '如何搜索想看的番剧？',
    answer: '您可以通过首页顶部的搜索框输入番剧名称进行搜索，也可以通过分类页面按类型（热血、恋爱、奇幻等）浏览。我们还提供热搜排行和最新更新列表，帮助您发现精彩内容。',
  },
  {
    question: '观看时出现卡顿怎么办？',
    answer: '如果遇到播放卡顿，建议先尝试切换清晰度（从高清切换至标清），或检查网络连接稳定性。91动漫已部署CDN加速节点，正常情况下可以提供流畅的播放体验。如问题持续，请联系客服。',
  },
];